var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('action',{attrs:{"title":_vm._f("startcase")(_vm.$t('clear_filters')),"text":_vm._f("startcase")(_vm.$t('clear_filters')),"icon":['fas', 'times-circle']},on:{"click":function($event){return _vm.clearFilters()}}})}
var staticRenderFns = []

export { render, staticRenderFns }